import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { foreignBusinessSponsorshipAddressNameFields } from 'constants/enums/people';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { ForeignBusinessSponsorshipModel } from './types';
import { foreignBusinessSponsorshipItemValidator } from './validators/item';

const foreignBusinessSponsorshipValidator: ValidateJSModel<ForeignBusinessSponsorshipModel> = {
  HasForeignSponsorship: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes, attributeName, options) => {
    if (attributes?.HasForeignSponsorship?.value === 'Yes') {
      let additionalValidation = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, foreignBusinessSponsorshipAddressNameFields);
      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.people.error.duplicateListItems',
          }
        };
      }
      return {
        presence: true,
        ...additionalValidation,
        accordion: { validator: foreignBusinessSponsorshipItemValidator },
      };
    }

    return {};
  },
};
export default foreignBusinessSponsorshipValidator;
